import { isPc } from '@/utils/utils';
import { Button, Modal } from 'antd-mobile';

import {
  FilterClientAreaPcProps,
  FilterClientAreaPc,
} from './FilterClientArea/FilterClientAreaPc';
import {
  TimePicker,
  Flex,
  Select as SelectAntd,
  SelectProps,
  InputProps,
  Input as InputAntd,
  Select,
  message
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { DateRangePickPc, DateRangePickPcProps } from './DateRangePick/DateRangePickPc';
import { DateRangePickMobile } from './DateRangePick/DateRangePickMobile';
import React, { useContext } from 'react';
import {
  FilterAccountStatusprops,
  FilterClientAreaProps,
  FilterClientTypeProps,
  FilterCollaboratorProps,
  FilterCommonInnerProps,
  FilterDatePickProps,
  FilterGoodsBrandProps,
  FilterInputProps,
  FilterSelectProps,
  FilterSelectWarehouseTypeProps,
  FilterDateUnitPickProps,
  FilterStaffBranchProps,
  FilterStaffProps,
  RangePick,
  FilterGoodsTagsPcprops,
  FilterTagsprops,
  FilterSelectWarehouseProps,
  FilterSelectGoodsProps,
  FilterPutAwayProps,
  FilterGoodsTypeProps,
  FilterGoodsCategoryProps,
  FilterCommonProps,
  FilterTypes,
  FilterAffiliateCollaboratorProps,
  FilterAll,
  FilterProps,
} from '../FilterCommon/Filter';
import './filterPc.less';
import { FilterStaffPc, FilterStaffPcProps } from './FilterStaff/FilterStaffPc';
import { FilterStaffBranchPc, FilterStaffBranchPcProps } from './FilterStaffBranch/FilterStaffBranchPc';
import { DatePickPc, DatePickPcProps } from './DatePick/DatePickPc';
import { FilterSelectPc } from './FilterSelect/FilterSelectPc';
import { FilterClientType, FilterClientTypePcProps } from './FIlterClientType/FilterClientType';
import dayjs from 'dayjs'
import styled from 'styled-components';
// import { GoodsBrand, GoodsBrandProps, GoodsCategory, GoodsCategoryProps, GoodsType, GoodsTypeProps } from './Goods/Goods';
import FilterGoodsCategoryPc, { FilterGoodsCategoryPcProps } from './FilterGoodsCategory/FilterGoodsCategoryPc';
import FilterGoodsBrandPc, { FilterGoodsBrandPcProps } from './FilterGoodsBrand/FilterGoodsBrandPc';
import FilterGoodsTypePc, { FilterGoodsTypePcProps } from './FilterGoodsType/FilterGoodsTypePc';
import FilterSelectGoodsPc, { FilterSelectGoodsPcProps } from './FilterSelectGoods/FilterSelectGoodsPc';
import FilterSelectWarehouseTypePc, { FilterSelectWarehouseTypePcProps } from './FilterSelectWarehouseType/FilterSelectWarehouseTypePc';
import FilterCollaboratorPc, { FilterCollaboratorPcProps } from './FilterCollaborator/FilterCollaboratorPc';
import FilterSelectWarehousePc, { SelectWarehousePcProps } from './FilterSelectWarehouse/FilterSelectWarehousePc';
import FilterTagsPc, { TagsPcProps } from './FilterTags/FilterTagsPc';
import FilterAccountStatusPc, { AccountStatusProps } from './FilterAccountStatus/FilterAccountStatusPc';
import FilterClientTagsPc, { ClientTagsPcProps } from './FilterClientTags/FilterClientTagsPc';
import FilterGoodsTagsPc, { GoodsTagsPcProps } from './FilterGoodsTags/FilterGoodsTagsPc';
import {FilterAffiliateCollaboratorPc, FilterAffiliateCollaboratorPcProps } from './FilterAffiliateCollaborator/FilterAffiliateCollaboratorPc';
import { FilterDeliverTypePc, FilterDeliverTypePcProps } from './FilterDeliverType/FilterDeliverTypePc';
import { FilterClientPc, FilterClientPcProps } from './FilterClient/FilterClientPc';
import { FilterCouponPc, FilterCouponProps } from './FilterCoupon/FilterCoupon';
import { FilterCouponStatus ,FilterCouponStatusProps } from './FilterCouponStatus/FilterCouponStatus';
import { FilterIssueMode, FilterIssueModeProps } from './FilterIssueMode/FilterIssueMode';
import { FilterFullPromotion, FilterFullPromotionProps } from './FilterFullPromotion/FilterFullPromotion';
import { FilterPromotionWay, FilterPromotionWayProps } from './FilterPromotionWay/FilterPromotionWay';
import { FilterActivityStatus, FilterActivityStatusProps } from './FilterActivityStatus/FilterActivityStatus';
import { FilterGoodsPromotion, FilterGoodsPromotionProps } from './FilterGoodsPromotion/FilterGoodsPromotion';
import { FilterPromotionType, FilterPromotionTypeProps } from './FilterPromotionType/FilterPromotionType';
import { FilterSort, FilterSortProps } from './FilterSort/FilterSort';
import UrlParamsContext, { UrlParamsContextType } from '../../context/urlParamsContext';
import { FilterStoreNamePc, FilterStoreNamePcProps } from './FilterStoreName/FilterStoreNameSearchModelPc';
import { FilterSupplierPc, FilterSupplierPcProps } from './FilterSupplier/FilterSupplierPc';

// export type FilterAllPc =
//   | FilterClientAreaProps
//   | RangePick
//   | FilterStaffProps
//   | FilterSelectProps
//   | FilterInputProps
//   | FilterStaffBranchProps
//   | FilterDatePickProps
//   | FilterClientTypeProps
//   | FilterGoodsCategoryProps
//   | FilterGoodsBrandProps
//   | FilterGoodsTypeProps
//   | FilterPutAwayProps
//   | FilterSelectGoodsProps
//   | FilterSelectWarehouseTypeProps
//   | FilterCollaboratorProps
//   | FilterSelectWarehouseProps
//   | FilterTagsprops
//   | FilterGoodsTagsPcprops
//   | FilterAccountStatusprops
//   | FilterDateUnitPickProps
//   | FilterAffiliateCollaboratorProps

// export type FilterAll = FilterAllPc
// export interface FilterProps {
//     // filters: FilterAllPc[];
//     filters: FilterAll[];
//     rowFlex?: number   //行等分数，默认7
//     onChangeValues(dataIndex: string, value: any,source?: any): void;
//     showFilter?:boolean;
//     values?: any;
// }
  

// import SelectGoods, { SelectGoodsProps } from './Goods/SelectGoods';
const Option = Select.Option;


interface FilterPcProps extends Omit<FilterCommonProps,'type'> {
  onChangeValues: (dataIndex: string, value: any, source?: any) => void;
  values: any;
  isAiChat?: boolean;
}
type FilterPcPropsGeneric<T> = FilterPcProps & T

//会存在page生成组件当前props传递下来
// export const FilterComponents: { [x in FilterAll['type']]?: React.FC<any> } = {
export const FilterComponents = {
 [FilterTypes.ClientArea]: (props:FilterPcProps & FilterClientAreaPcProps)=>{
    const { dataIndex,onChangeValues,...rest } = props
    return <FilterClientAreaPc
      {...rest}
      onChange={(value, labelList,extra) => {
        props.onChange && props.onChange(value, labelList,extra);
        props.onChangeValues(dataIndex, value, { value, labelList,extra});
      }}
    />
  },
 [FilterTypes.ClientType]:(props:FilterPcProps & FilterClientTypePcProps)=>{
    const { dataIndex,onChangeValues,...rest } = props
    return <FilterClientType
      {...rest}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value, { value, option});
      }}
    />
  },
 [FilterTypes.RangePick]: (props:FilterPcProps & DateRangePickPcProps)=>{
    const { dataIndex,onChangeValues, values, value,...rest } = props;
    // dataIndex
    const rangeDate = dataIndex.split(',')
    const startIndex = rangeDate[0];
    const endIndex = rangeDate[1];
    // value
    const startValue = values[startIndex];
    const endValue = values[endIndex];
    return <DateRangePickPc
      {...rest}
      value={[startValue, endValue]}
      onChange={(dates, dateStrings) => {
        const startTimeValue = dates?.[0] ? dayjs(dates[0]).format('YYYY-MM-DD HH:mm:ss') : undefined;
        const endTimeValule = dates?.[1] ? dayjs(dates[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined;
        props.onChange && props.onChange(dates, dateStrings); // antd表单内部change

        props.onChangeValues(startIndex, startTimeValue, { dates, dateStrings }); // 外部保存的value
        props.onChangeValues(endIndex, endTimeValule, { dates, dateStrings }); // 外部保存的value
      }}
    />
  },
 [FilterTypes.Staff]: (props:FilterPcProps & FilterStaffPcProps)=>{
    const { dataIndex,onChangeValues,...rest } = props
    return <FilterStaffPc 
      {...rest}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value, { value, option });
      }}
    />
  },
 [FilterTypes.StaffBranch]: (props:FilterPcProps & FilterStaffBranchPcProps)=>{
    const { dataIndex, onChangeValues, ...rest } = props
    return <FilterStaffBranchPc
      // onChangeValues(dataIndex, value);
      {...rest}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value, { value, option });
      }}
    />
  },
 [FilterTypes.Select]: (props: FilterPcProps & SelectProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return (
      <FilterSelectPc
        {...reset}
        onChange={(value, option) => {
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
      />
    );
    // return (
    //   <SelectAntd
    //     allowClear
    //     style={{ width: '100%' }}
    //     {...reset}
    //     onChange={(value, option) => {
    //       props.onChange && props.onChange(value, option);
    //       props.onChangeValues(dataIndex, value);
    //     }}
    //   />
    // );
  },
 [FilterTypes.GoodsCategory]: (props: FilterPcProps & FilterGoodsCategoryPcProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;

    return <FilterGoodsCategoryPc
      mode='multiple'
      {...reset}
      onChange={(value, labelList, extra) => {
        props.onChange && props.onChange(value, labelList, extra);
        props.onChangeValues(dataIndex, value, { value, labelList, extra });
      }}
    />
  }, 
 [FilterTypes.GoodsBrand]:(props: FilterPcProps & FilterGoodsBrandPcProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return <FilterGoodsBrandPc
      mode='multiple'
      {...reset}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
    />
  }, 
 [FilterTypes.GoodsType]:(props: FilterPcProps & FilterGoodsTypePcProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return <FilterGoodsTypePc
      mode='multiple'
      {...reset}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
    />
  },
 [FilterTypes.PutAway]:(props: FilterPcProps & SelectProps)=>{
    const { value, placeholder='上下架',dataIndex,onChangeValues,...rest } = props;
      return <Select
            showSearch
            allowClear
            dropdownClassName="filter-select"
            style={{ width: '100%' }}
            value={value}
            mode='multiple'
            placeholder={placeholder}
            // getPopupContainer={(triggerNode) => triggerNode.parentNode}
            // defaultActiveFirstOption={false}
            // filterOption={(input, option) => option.props.children.includes(input)}
            {...rest}
            onChange={(value, option) => {
              props.onChange && props.onChange(value, option);
              props.onChangeValues(dataIndex, value);
            }}
        >
          <Option key="T" value="T">上架</Option>
          <Option key="F" value="F">下架</Option> 
    </Select>
  },
 [FilterTypes.SelectGoods]: (props: FilterPcProps & FilterSelectGoodsPcProps) => {
    const { value, dataIndex, onChangeValues, isAiChat, ...rest } = props;
    
    return <FilterSelectGoodsPc
      value={value}
      isAiChat={isAiChat}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
      {...rest}
    />

  },
 [FilterTypes.SelectWarehouse]: (props: FilterPcProps & SelectWarehousePcProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return <FilterSelectWarehousePc
      {...reset}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
    />
  },
 [FilterTypes.SelectWarehouseType]: (props: FilterPcProps & FilterSelectWarehouseTypePcProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return <FilterSelectWarehouseTypePc
      {...reset}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
    />
  },
 [FilterTypes.Collaborator]:(props: FilterPcProps & FilterCollaboratorPcProps)=>{
    const { value, dataIndex,onChangeValues, ...rest } = props;
    
    return <FilterCollaboratorPc
      value={value}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
      {...rest}
    />
  },
 [FilterTypes.ClientTags]:(props: FilterPcProps & ClientTagsPcProps)=>{
    const { value, dataIndex,onChangeValues, ...rest } = props;
    const [clientTags,setClientTags] = React.useState<string[]>(value||[])
    
    return <FilterClientTagsPc
      value={clientTags}
      onChange={(value, option) => {
        setClientTags(value);
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
      {...rest}
    />
  },
 [FilterTypes.GoodsTags]:(props: FilterPcProps & GoodsTagsPcProps)=>{
    const { value, dataIndex,onChangeValues, ...rest } = props;
    const [clientTags,setClientTags] = React.useState<string[]>(value||[])
    
    return <FilterGoodsTagsPc
      value={clientTags}
      onChange={(value, option) => {
        setClientTags(value);
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
      {...rest}
    />
  },
 [FilterTypes.AccountStatus]:(props: FilterPcProps & AccountStatusProps)=>{
    const { value, dataIndex,onChangeValues, ...rest } = props;
    
    return <FilterAccountStatusPc
      value={value}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value);
      }}
      {...rest}
    />
  },
 [FilterTypes.Input]: (props: FilterPcProps & InputProps) => {
    const { dataIndex,onChangeValues, ...reset } = props;
    return (
      <InputAntd
        prefix={<SearchOutlined />}
        allowClear
        style={{ width: '100%' }}
        {...reset}
        onChange={(e) => {
          let value = e.target.value;
          props.onChange && props.onChange(e);
          props.onChangeValues(dataIndex, value);
        }}
      />
    );
  },
 [FilterTypes.DatePick]:(props: FilterPcProps & DatePickPcProps)=>{
    let { dataIndex, onChangeValues, value, ...reset } = props

    return <DatePickPc
      {...reset}
      value={value ? dayjs(value) : value}
      onChange={(date,DataString)=>{
        props.onChange && props.onChange(date,DataString);
        onChangeValues(dataIndex, DataString,{date,DataString});
      }}
    />
  },
  [FilterTypes.DateUnitPick]:(props: FilterPcProps & DatePickPcProps & {dataIndexTwo:string})=>{
    let { dataIndex, dataIndexTwo, onChangeValues, value, ...reset } = props
    return <DatePickPc
      {...reset}
      value={value ? dayjs(value) : value}
      startDay
      onChange={(date, DataString) => {
        props.onChange && props.onChange(date, DataString);
        onChangeValues(dataIndex, DataString, { date, DataString });
        const changeEndDate = () => {
          let endDate = date.endOf(reset?.picker || 'day' as any)
          let format = 'YYYY-MM-DD HH:mm:ss'
          let endDateString = endDate.format(format)
          onChangeValues(dataIndexTwo, endDate.format(format), { date: endDate, DataString: endDateString });
        }
        changeEndDate()
      }
    }
    />
  },
  [FilterTypes.AffiliateCollaborator]:(props: FilterPcPropsGeneric<FilterAffiliateCollaboratorPcProps>)=>{
    let { dataIndex, onChangeValues, value, ...reset } = props
    return <FilterAffiliateCollaboratorPc
      value={value }
      onChange={(value,option)=>{
        props.onChange && props.onChange(value,option);
        props.onChangeValues(dataIndex, value);
      }}
      {...reset}
    />
  },
  [FilterTypes.DeliverType]:(props: FilterPcPropsGeneric<FilterDeliverTypePcProps>)=>{
    let { dataIndex, onChangeValues, value, ...reset } = props
    return <FilterDeliverTypePc
      value={value }
      onChange={(value,option)=>{
        props.onChange && props.onChange(value,option);
        props.onChangeValues(dataIndex, value);
      }}
      {...reset}
    />
  },
  [FilterTypes.Client]:(props: FilterPcPropsGeneric<FilterClientPcProps>)=>{
    let { dataIndex, onChangeValues, value, ...reset } = props
    return <FilterClientPc
      value={value }
      onChange={(value,option)=>{
        props.onChange && props.onChange(value,option);
        props.onChangeValues(dataIndex, value);
      }}
      {...reset}
    />
  },
  [FilterTypes.Coupon]:(props: FilterPcPropsGeneric<FilterCouponProps>)=>{
    let { dataIndex, onChangeValues, value, ...reset } = props
    return <FilterCouponPc
      value={value}
      onChange={(value,option)=>{
        props.onChange && props.onChange(value,option);
        props.onChangeValues(dataIndex, value);
      }}
      {...reset}
    />
  },
  [FilterTypes.CouponStatus]: (props: FilterPcPropsGeneric<FilterCouponStatusProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterCouponStatus
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.IssueMode]: (props: FilterPcPropsGeneric<FilterIssueModeProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterIssueMode
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.Promotion]: (props: FilterPcPropsGeneric<FilterFullPromotionProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterFullPromotion
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.PromotionWay]: (props: FilterPcPropsGeneric<FilterPromotionWayProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterPromotionWay
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.ActivityStatus]: (props: FilterPcPropsGeneric<FilterActivityStatusProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterActivityStatus
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.GoodsPromotion]: (props: FilterPcPropsGeneric<FilterGoodsPromotionProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props;
    const contextData = useContext(UrlParamsContext) as Array<UrlParamsContextType>
    const goodsPromotionItem = contextData?.find(item => item.filterType == FilterTypes.GoodsPromotion);
    const { promotion_type } = goodsPromotionItem || {} as UrlParamsContextType;
    return (
      <FilterGoodsPromotion
        value={value}
        promotion_type={promotion_type}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.PromotionType]: (props: FilterPcPropsGeneric<FilterPromotionTypeProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterPromotionType
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
  [FilterTypes.Sort]: (props: FilterPcPropsGeneric<FilterSortProps>) => {
    let { dataIndex, onChangeValues, value, ...reset } = props
    return (
      <FilterSort
        value={value}
        onChange={(value, option)=>{
          props.onChange && props.onChange(value, option);
          props.onChangeValues(dataIndex, value);
        }}
        {...reset}
      />
    )
  },
   [FilterTypes.FilterStore]: (props:FilterPcProps & FilterStoreNamePcProps)=>{
    const { dataIndex,onChangeValues,...rest } = props
    return <FilterStoreNamePc 
      {...rest}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value, { value, option });
      }}
    />
  },
  [FilterTypes.FilterSupplier]: (props: FilterPcProps & FilterSupplierPcProps) => {
    const { dataIndex,onChangeValues, ...rest } = props;
    return <FilterSupplierPc 
      {...rest}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        props.onChangeValues(dataIndex, value, { value, option });
      }}
    />
  },
};


// function CommonFilterComponent<T extends (FilterPcProps & { onChange: (value: any, option: any) => void }),F extends React.FC<T>>(Fn:F,props:T){
//   let { dataIndex, onChangeValues, value, ...reset } = props
//   return <Fn
//     // onChange={(value, option) => {
//     //   props.onChange && props.onChange(value, option);
//     //   props.onChangeValues(dataIndex, value);
//     // }}
//     {...reset}
//   />
// }



const FilterPcView = styled(Flex)`
  .ant-select-multiple .ant-select-selection-overflow{
    overflow: hidden;
    flex-wrap: nowrap;
  }

`


export const FilterPc = (props: FilterProps) => {

  const [viewportWidth, setViewportWidth] = React.useState<number>(window.innerWidth || document.documentElement.clientWidth)
  React.useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth || document.documentElement.clientWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const onChangeValues = (dataIndex: string, value: any,source?: any) => {
    console.log(dataIndex, value,source);
    if(Array.isArray(value) && value.length > 100 ){
      message.warning({
        content:'不能超过100个'
      })
      return
    }
    props.onChangeValues(dataIndex, value,source);
  };
  let values = props.values || {};
  const { rowFlex = 7 } = props
  return (
    <FilterPcView wrap="wrap">
      {props.filters.map((item, index) => {
        let { dataIndex, flex = 1,  type, ...reset } = item;
        let Component = FilterComponents[type] as React.FC<any>;
        if (!Component) {
          console.error(`${type} not find`);
          return null;
        }
        let value = values[dataIndex]
        if(value === undefined){
          value = item.value;
        }
        // let value = values[dataIndex] || item.value;
        let width = Math.floor(1/rowFlex * 100 * Number(flex))   + '%'
        if (props.isAiChat) {
          if (viewportWidth <= 500) {
            width = '100%'
          } else if (viewportWidth <= 900) {
            width = '50%'
          } else {
            width = '25%'
          }
        }
        let isHidden  = props.showFilter?'flex':index<rowFlex?'flex':'none'

        return (
          <div
            key={index}
            style={{ width, display: isHidden, alignItems: 'center', padding: '0px 10px 10px 0px', boxSizing:'border-box', }}
          >
            {/* {label && (  <span style={{ width: '100px', textAlign: 'right' }}>   {label}：  </span> )} */}
            <div style={{ flex: 1, width:'100%' }}>
              <Component
                {...reset}
                onChangeValues={onChangeValues}
                dataIndex={dataIndex}
                value={value}
                values={values}
                {...(type === FilterTypes.SelectGoods && { isAiChat: props.isAiChat })}
              />
            </div>
          </div>
        );
      })}
    </FilterPcView>
  );
};

export default FilterPc;
